import React, { useState, useEffect, createContext, HTMLAttributes } from 'react';
import styled from 'styled-components';

const AccordionElement = styled.div`
    max-width: 100%;
    border: 1px solid;
`;

export type UUID = string | number;

interface IAccordionProps extends HTMLAttributes<HTMLDivElement> {
    expandedItems?: UUID[];
    allowMultipleExpanded?: boolean;
    allowZeroExpanded?: boolean;
}

interface IAccordionContext extends IAccordionProps {
    updateExpandedItems: (x: UUID[]) => void;
}

export const AccordionContext = createContext<IAccordionContext>(null);

export default function Accordion(props: IAccordionProps): JSX.Element {
    const { expandedItems = [], children, className, allowMultipleExpanded = false, allowZeroExpanded = false } = props;
    const [expandedItemsState, setExpandedItems] = useState(expandedItems);

    useEffect((): void => {
        setExpandedItems(expandedItems);
    }, [JSON.stringify(expandedItems)]);

    function updateExpandedItems(newExpandedItemsState: UUID[]): void {
        setExpandedItems(newExpandedItemsState);
    }

    return (
        <AccordionContext.Provider
            value={{ expandedItems: expandedItemsState, updateExpandedItems, allowMultipleExpanded, allowZeroExpanded }}
        >
            <AccordionElement className={className}>{children}</AccordionElement>
        </AccordionContext.Provider>
    );
}
